import { cn } from '@src/design-system/helpers';
import type { ComponentProps } from 'react';

export function PageContainer({
  children,
  className,
  ...props
}: ComponentProps<'div'>) {
  return (
    <div
      className={cn(
        'p-4 flex flex-col gap-4 min-h-[100dvh] bg-primary-50',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
